import React, { useState } from "react";
import { Row, Col, Modal, Table, Button, Form, Alert } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import ConversionActionIds from "./ConversionActionIds";
import testCampaignGroupFilters from "utils/testCampaignGroupFilters";
import CustomTooltip from "utils/CustomTooltip";
import CustomConversions from "client_config/ppc_config/social/ids_data/CustomConversions";

export default function EditCampaignGroup(props) {
  let edit = require("images/icons/edit.png");
  edit = <img style={{ marginBottom: "8px", cursor: "pointer" }} src={`/datapulse${edit}`} />;

  const [showBox, setShowBox] = useState(false);

  const clearFields = (item, input) => {
    document.getElementById(`${item}`).value = "";
  };
  const [testString, setTestString] = useState("");
  const [conversionActionsEnabled, setConversionActionsEnabled] = useState(props.item ? props.item.conversion_actions_enabled : false);
  const [conversionActions, setConversionActions] = useState(props.item ? props.item.conversion_actions : []);
  // Only used for social
  const [conversionObjective, setConversionObjective] = useState(props.item ? props.item.conversion_objective : props.social_section.conversion_objective);
  const [customConversions, setCustomConversions] = useState(props.item ? props.item.custom_conversions : []);
  const [tiktokConversionObjective, setTiktokConversionObjective] = useState(props.item ? props.item.tiktok_conversion_objective : props.social_section.tiktok_conversion_objective);
  // Error handling
  const [errorText, setErrorText] = useState([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const newName = $(".campaign-name").val();
    const conversionActionsLabels = $(".conversion-actions-label").map(function() { return $(this).val(); }).toArray();
    const conversionActionsIds = $(".conversion-actions-id").map(function() { return $(this).val(); }).toArray();
    const customConversionsLabels = $(".social-custom-conversions-label").map(function() { return $(this).val(); }).toArray();
    const customConversionsIds = $(".social-custom-conversions-id").map(function() { return $(this).val(); }).toArray();
    let errorsPresent = false;
    let errors = [];

    if (newName === undefined || newName === "") {
      errorsPresent = true;
      errors.push("You must include a campaign group name")
    }
    if (conversionActionsEnabled && conversionActions.length > 0 && conversionActionsLabels.includes("")) {
      errorsPresent = true;
      errors.push("All conversion actions must have a label")
    }
    if (conversionActionsEnabled && conversionActions.length > 0 && conversionActionsIds.includes("")) {
      errorsPresent = true;
      errors.push("All conversion actions must have an ID")
    }
    // check the props if this is the social section
    if (props.platformType === "Social" && conversionObjective === "custom_conversions" && customConversions.length > 0 && customConversionsLabels.includes("")) {
      errorsPresent = true;
      errors.push("All custom conversions must have a label")
    }
    if (props.platformType === "Social" && conversionObjective === "custom_conversions" && customConversions.length > 0 && customConversionsIds.includes("")) {
      errorsPresent = true;
      errors.push("All custom conversions must have an ID")
    }

    setErrorText(errors);

    if (!errorsPresent) {
      setShowBox(false);
      props.handleEditBox(
        props.item.id,
        props.item.name,
        "",
        "",
        "",
        containsTerms,
        notContainsTerms,
        conversionActionsEnabled,
        conversionActions,
        customConversions,
        conversionObjective,
        tiktokConversionObjective,
        containsPreviewModifier,
        notContainsPreviewModifier
      );
    }
  }

  let containsAnd = [];
  let containsOr = [];
  let notContainsAnd = [];
  let notContainsOr = [];
  let containsTerms = [];
  let notContainsTerms = [];
  if (props.item.conditions.contains) {
    if (props.item.conditions.contains.and)
      containsAnd = Array.isArray(props.item.conditions.contains.and)
        ? props.item.conditions.contains.and
        : props.item.conditions.contains.and.split(",");
    if (props.item.conditions.contains.or)
      containsOr = Array.isArray(props.item.conditions.contains.or)
        ? props.item.conditions.contains.or
        : props.item.conditions.contains.or.split(",");
  }
  if (props.item.conditions.not_contains) {
    if (props.item.conditions.not_contains.and)
      notContainsAnd = Array.isArray(props.item.conditions.not_contains.and)
        ? props.item.conditions.not_contains.and
        : props.item.conditions.not_contains.and.split(",");
    if (props.item.conditions.not_contains.or)
      notContainsOr = Array.isArray(props.item.conditions.not_contains.or)
        ? props.item.conditions.not_contains.or
        : props.item.conditions.not_contains.or.split(",");
  }
  containsTerms = containsAnd.length > 0 && !(containsAnd.length == 1 && containsAnd[0] == "") ? containsAnd : containsOr;
  notContainsTerms = notContainsAnd.length > 0 && !(notContainsAnd.length == 1 && notContainsAnd[0] == "") ? notContainsAnd : notContainsOr;

  const [containsPreviewModifier, setContainsPreviewModifier] = useState(
    containsAnd.length > 0 && !(containsAnd.length == 1 && containsAnd[0] == "") ? "and" : "or"
  );
  const [notContainsPreviewModifier, setNotContainsPreviewModifier] = useState(
    notContainsAnd.length > 0 && !(notContainsAnd.length == 1 && notContainsAnd[0] == "") ? "and" : "or"
  );
  const [showAlert1, setShowAlert1] = useState(false);
  const [showAlert2, setShowAlert2] = useState(false);

  const testStringMatches = testCampaignGroupFilters({ contains: { [containsPreviewModifier]: containsTerms }, notContains: { [notContainsPreviewModifier]: notContainsTerms } }, testString) == true

  return (
    <div>
      <div className="text-right m-3">
        <Button onClick={(e) => setShowBox(true)} variant="outline-success">
          {edit}
        </Button>
      </div>
      {/* Popup Modal */}
      <Modal className="campaign-modal" show={showBox} onHide={(e) => setShowBox(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Campaign Groups</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className="cg-col" lg={7} xs={12}>
              {/* <p className="f22 visby-bold primary">Configure Campaign Groups</p> */}
              <Row className="align-items-center mb-3 mt-3">
                <Col style={{ maxWidth: "60px" }}>
                  <p className="f16 pb-2 pb-md-0 visby-bold primary">Name:</p>
                </Col>
                <Col md={8} className="pl-md-5 pl-3 collapse-padding-mobile campaign-name-box">
                  <Form.Control
                    style={{ width: "100%" }}
                    className="campaign-name"
                    size="md"
                    value={props.item.name}
                    onChange={(e) => {
                      props.handleEditBox(
                        props.draggableId,
                        e.target.value,
                        "",
                        "",
                        "",
                        containsTerms,
                        notContainsTerms,
                        conversionActionsEnabled,
                        props.item,
                        conversionActions,
                        customConversions,
                        conversionObjective,
                        tiktokConversionObjective,
                        containsPreviewModifier,
                        notContainsPreviewModifier
                      );
                    }}
                    placeholder="Search: Campaign Group Name 1"
                  />
                </Col>
              </Row>
              <Row className="filter-terms">
                <Col>
                  <p className="f16 visby-bold  primary pb-2 pr-5"> Contains:</p>
                  <div>
                    <Form.Control
                      style={{ width: "200px" }}
                      name="contains_term"
                      size="sm"
                      placeholder="Type term here..."
                      onFocus={(e) => {
                        setShowAlert1(false);
                      }}
                      onChange={(e) => {
                        props.setContainsInput(e.target.value);
                      }}
                      id="contains_term"
                    />
                  </div>
                  {showAlert1 === true ? (
                    <Alert className="mt-3 over-modal fade show" variant="danger">
                      <Row>
                        <Col className="pr-0 pt-2 pb-3">
                          {props.containsInput !== "" ? (
                            <>
                              <p className="pl-3 pt-3">
                                The keyword "<strong>{props.containsInput}</strong>" already exists!
                              </p>
                            </>
                          ) : (
                            <>
                              <p className="pl-3 pt-3">You must include a term!</p>
                            </>
                          )}
                        </Col>
                        <Col md={3}>
                          <p
                            style={{ cursor: "pointer" }}
                            className="f20 pt pr-2"
                            onClick={(e) => {
                              setShowAlert1(false);
                              props.setContainsInput("");
                            }}>
                            x
                          </p>
                        </Col>
                      </Row>
                    </Alert>
                  ) : undefined}
                  <div className="text-center text-md-left add-term-btn ">
                    <Button
                      style={{
                        paddingLeft: "25px",
                        paddingRight: "25px",
                        paddingTop: "3px",
                        paddingBottom: "3px",
                      }}
                      variant="success"
                      className="my-3"
                      onClick={() => {
                        let tempContainsTerms = containsTerms.map((el) => el.toLowerCase());
                        let tempNotContainsTerms = notContainsTerms.map((el) => el.toLowerCase());
                        let tempValue = props.containsInput.toLowerCase();
                        clearFields("contains_term");
                        if (tempContainsTerms.includes(tempValue) || props.containsInput == "") setShowAlert1(true);
                        else
                          props.handleEditBox(
                            props.item.id,
                            props.item.name,
                            props.containsInput,
                            "contains",
                            "add",
                            tempContainsTerms,
                            tempNotContainsTerms,
                            conversionActionsEnabled,
                            conversionActions,
                            customConversions,
                            conversionObjective,
                            tiktokConversionObjective,
                            containsPreviewModifier,
                            notContainsPreviewModifier
                          );

                        {
                          showAlert1 === true && props.setContainsInput("");
                        }
                      }}>
                      + Add term
                    </Button>
                  </div>
                  <div className="term-box  p-3">
                    {containsTerms[0] !== "" &&
                      containsTerms.map((term, idx) => {
                        return (
                          <div key={`contains-term-${idx}`} className="mb-2 term d-inline-block">
                            <span className="primary">{term}</span>
                            <span
                              style={{ color: "#808080", cursor: "pointer" }}
                              className="pl-3 "
                              onClick={(e) => {
                                props.handleEditBox(
                                  props.item.id,
                                  props.item.name,
                                  term,
                                  "contains",
                                  "remove",
                                  containsTerms,
                                  notContainsTerms,
                                  conversionActionsEnabled,
                                  conversionActions,
                                  customConversions,
                                  conversionObjective,
                                  tiktokConversionObjective,
                                  containsPreviewModifier,
                                  notContainsPreviewModifier
                                );
                                setShowAlert1(false);
                              }}>
                              x
                            </span>
                          </div>
                        );
                      })}
                  </div>
                </Col>
                <Col>
                  <p className="f16 pb-2  visby-bold primary"> Does not contain:</p>
                  <div>
                    <Form.Control
                      style={{ width: "200px" }}
                      name="does_not_contain_term"
                      id="does_not_contain_term"
                      size="sm"
                      placeholder="Type term here..."
                      onFocus={(e) => {
                        setShowAlert2(false);
                      }}
                      onChange={(e) => props.setNotContainsInput(e.target.value)}
                    />
                    {showAlert2 === true ? (
                      <Alert className="mt-3 over-modal fade show" variant="danger">
                        <Row>
                          <Col className="pr-0 pt-2 pb-3">
                            {props.notContainsInput === "" ? (
                              <p className="pl-3 pt-3">You must include a term!</p>
                            ) : (
                              <>
                                <p className="pl-3 pt-3">
                                  The keyword "<strong>{props.notContainsInput}</strong>" already exists!
                                </p>
                              </>
                            )}
                          </Col>
                          <Col md={3}>
                            <p
                              style={{ cursor: "pointer" }}
                              className="f20 pr-2"
                              onClick={(e) => {
                                setShowAlert2(false);
                                props.setContainsInput("");
                              }}>
                              x
                            </p>
                          </Col>
                        </Row>
                      </Alert>
                    ) : undefined}
                  </div>
                  <div className="text-center text-md-left add-term-btn ">
                    <Button
                      style={{
                        paddingLeft: "25px",
                        paddingRight: "25px",
                        paddingTop: "3px",
                        paddingBottom: "3px",
                      }}
                      variant="success"
                      className="my-3"
                      onClick={() => {
                        let tempContainsTerms = containsTerms.map((el) => el.toLowerCase());
                        let tempNotContainsTerms = notContainsTerms.map((el) => el.toLowerCase());
                        let tempValue = props.notContainsInput.toLowerCase();
                        clearFields("does_not_contain_term");
                        if (tempNotContainsTerms.includes(tempValue) || props.notContainsInput == "") setShowAlert2(true);
                        else
                          props.handleEditBox(
                            props.item.id,
                            props.item.name,
                            props.notContainsInput,
                            "notContains",
                            "add",
                            tempContainsTerms,
                            tempNotContainsTerms,
                            conversionActionsEnabled,
                            conversionActions,
                            customConversions,
                            conversionObjective,
                            tiktokConversionObjective,
                            containsPreviewModifier,
                            notContainsPreviewModifier
                          );

                        clearFields("does_not_contain_term");
                        {
                          showAlert2 === true && props.setNotContainsInput("");
                        }
                      }}>
                      + Add term
                    </Button>
                  </div>
                  <div className="p-3 term-box">
                    {notContainsTerms[0] !== "" &&
                      notContainsTerms.map((term, idx) => {
                        return (
                          <div key={`notContains-term-${idx}`} className="mb-2 term d-inline-block">
                            <span className="primary">{term}</span>
                            <span
                              style={{ color: "#808080", cursor: "pointer" }}
                              className="pl-3 "
                              onClick={(e) => {
                                props.handleEditBox(
                                  props.item.id,
                                  props.item.name,
                                  term,
                                  "notContains",
                                  "remove",
                                  containsTerms,
                                  notContainsTerms,
                                  conversionActionsEnabled,
                                  conversionActions,
                                  customConversions,
                                  conversionObjective,
                                  tiktokConversionObjective,
                                  containsPreviewModifier,
                                  notContainsPreviewModifier
                                );
                                setShowAlert2(false);
                              }}>
                              x
                            </span>
                          </div>
                        );
                      })}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Row className="my-3 align-items-center">
                    <Col className={props.onboarding ? "mr-4" : "mr-2"} md={5}>
                      <p style={{ whiteSpace: "nowrap" }} className="f14 text-center primary nunito-regular">
                        "Contains" modifier:
                      </p>
                    </Col>
                    <Col>
                      <Form.Control
                        className="primary "
                        onChange={(e) => {
                          setContainsPreviewModifier(e.target.value);
                          props.setContainsPreviewModifier(e.target.value);
                          props.handleEditBox(
                            props.item.id,
                            props.item.name,
                            props.containsInput,
                            "",
                            "",
                            containsTerms,
                            notContainsTerms,
                            conversionActionsEnabled,
                            conversionActions,
                            customConversions,
                            conversionObjective,
                            tiktokConversionObjective,
                            e.target.value,
                            notContainsPreviewModifier
                          );

                        }}
                        size="sm"
                        as="select"
                        style={{ width: "70px" }}
                        value={containsPreviewModifier}>
                        <option value="and">and</option>
                        <option value="or">or</option>
                      </Form.Control>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row className="my-3 align-items-center">
                    <Col className={props.onboarding ? "mr-4" : "mr-2"} md={5}>
                      <p style={{ whiteSpace: "nowrap" }} className="f14 primary text-center nunito-regular">
                        "Not contains" modifier:
                      </p>
                    </Col>
                    <Col>
                      <Form.Control
                        onChange={(e) => {
                          setNotContainsPreviewModifier(e.target.value);
                          props.setNotContainsPreviewModifier(e.target.value);
                          props.handleEditBox(
                            props.item.id,
                            props.item.name,
                            props.notContainsInput,
                            "",
                            "",
                            containsTerms,
                            notContainsTerms,
                            conversionActionsEnabled,
                            conversionActions,
                            customConversions,
                            conversionObjective,
                            tiktokConversionObjective,
                            containsPreviewModifier,
                            e.target.value
                          );
                        }}
                        className="primary "
                        size="sm"
                        as="select"
                        style={{ width: "70px" }}
                        value={notContainsPreviewModifier}>
                        <option value="and">and</option>
                        <option value="or">or</option>
                      </Form.Control>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row className="p-3 mb-4" style={{ backgroundColor: "#F5F5F5" }}>
                <Col>
                  <Row className="mb-2">
                    <Col>
                      <p className="f16 visby-bold primary">Output preview:</p>
                    </Col>
                  </Row>
                  <Row className="d-flex mb-3 d-inline-block d-flex pr-5">
                    <Col style={{ marginRight: "35px" }} md={1}>
                      <p className="f16 nunito-regular primary bold pr-3">Contains:</p>
                    </Col>
                    <Col>
                      {containsPreviewModifier === "and"
                        ? containsTerms.map((text, index) => {
                          return (
                            <div key={text} style={{ display: "inline-flex" }}>
                              <span key={uuidv4()} className="f16 d-inline-block nunito-regular primary" style={{ marginBottom: "3px" }}>
                                {text}
                              </span>
                              {index < containsTerms.length - 1 && (
                                <span style={{ marginBottom: "3px" }} key={uuidv4()} className="styled-and d-inline-block">
                                  and
                                </span>
                              )}
                            </div>
                          );
                        })
                        : containsTerms.map((text, index) => {
                          return (
                            <div key={text} style={{ display: "inline-flex" }}>
                              <span key={uuidv4()} className="f16 d-inline-block nunito-regular primary" style={{ marginBottom: "3px" }}>
                                {text}
                              </span>
                              {index < containsTerms.length - 1 && (
                                <span style={{ marginBottom: "3px" }} key={uuidv4()} className="styled-or d-inline-block">
                                  or
                                </span>
                              )}
                            </div>
                          );
                        })}
                    </Col>
                  </Row>
                  <Row className="d-flex mb-2 d-inline-block d-flex pr-5">
                    <Col style={{ marginRight: "35px" }} md={2}>
                      <p style={{ whiteSpace: "nowrap" }} className="f16 nunito-regular danger bold pr-3">
                        Does not contain:
                      </p>
                    </Col>
                    <Col>
                      {notContainsPreviewModifier === "and"
                        ? notContainsTerms.map((text, index) => {
                          return (
                            <div key={text} style={{ display: "inline-flex" }}>
                              <span key={uuidv4()} className="f16 pl-0 pl-md-3 d-inline-block nunito-regular primary" style={{ marginBottom: "3px" }}>
                                {text}
                              </span>
                              {index < notContainsTerms.length - 1 && (
                                <span style={{ marginBottom: "3px" }} key={uuidv4()} className="styled-and d-inline-block">
                                  and
                                </span>
                              )}
                            </div>
                          );
                        })
                        : notContainsTerms.map((text, index) => {
                          return (
                            <div key={text} style={{ display: "inline-flex" }}>
                              <span key={uuidv4()} className="f16 d-inline-block nunito-regular primary" style={{ marginBottom: "3px" }}>
                                {text}
                              </span>
                              {index < notContainsTerms.length - 1 && (
                                <span style={{ marginBottom: "3px" }} key={uuidv4()} className="styled-or d-inline-block">
                                  or
                                </span>
                              )}
                            </div>
                          );
                        })}
                    </Col>
                  </Row>
                  <Row className="d-flex mt-3 mb-2 d-inline-block d-flex">
                    <Col>
                      <p style={{ whiteSpace: "nowrap" }} className="f16 visby-bold primary mb-2">
                        Test a campaign name:
                      </p>
                      <div className="d-flex">
                        <Form.Control
                          size="md"
                          onChange={(e) => setTestString(e.target.value)}
                          placeholder={"Add the name of a campaign here"}
                          value={testString}
                          style={testString != "" ? (
                            testStringMatches ? {
                              background: "rgba(0, 200, 0, .25)"
                            } : {
                              background: "rgba(200, 0, 0, .25)"
                            }
                          ) : {}}
                        />
                        <div style={{ height: "38px", width: "38px" }}>
                          {testString != "" && (
                            testStringMatches ? (
                              <i className="fas fa-check text-success" style={{ position: "relative", top: "5px", left: "calc(50% - 5px)" }}></i>
                            ) : (
                              <i className="fas fa-times text-danger" style={{ position: "relative", top: "5px", left: "calc(50% - 5px)" }}></i>
                            )
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col>
              <div className="px-md-3 px-0">
                <p className="visby-bold f16 primary pb-2">Instructions:</p>
                <p className="nunito-regular f14 primary pb-2">
                  First, configure your terms that you want to contain (or exclude) by typing the term in the top corresponding field and clicking "Add term".
                </p>
                <p className="nunito-regular f14 primary pb-2">
                  Then, select your modifier for each column to determine how those groups of terms will affect tracking. Choosing 'and' will detect and track
                  results in which <span className="bold">every</span> listed term is included. Choosing 'or' will detect and track{" "}
                  <span className="bold">any</span> result with <span className="bold">at least one</span> of the listed terms.
                </p>
                <p className="nunito-regular f14 primary pb-2">
                  Finally, read (and re-read) your output to ensure your "sentence structure" is correct. Remember, 'and' will only track results with{" "}
                  <span className="bold">all</span> terms, while 'or' will track results with <span className="bold">any</span> term.
                </p>
              </div>
            </Col>
          </Row>
          <hr className="divider"></hr>
          <Row>
            {props.platformType === "Social" ? (
              <Col className="d-flex" style={{ gap: "20px" }}>
                <div>
                  <p className="d-inline-block visby-bold primary f16 mb-3">Facebook Objective </p>
                  <CustomTooltip
                    faClass="far fa-question-circle pl-2"
                    message="Here you can set the objective for facebook conversions. Choose one of the pre-made settings from the dropdown, or use the custom conversions option to be more specific and input your own conversion IDs and labels (labels are simply to make your IDs easier to identify within DataPulse)."
                    inline={true}
                  />
                  <Form.Control
                    className="primary mb-2"
                    size="md"
                    as="select"
                    value={conversionObjective}
                    onChange={(e) => setConversionObjective(e.target.value)}
                    style={{
                      width: "256px",
                      paddingLeft: "20px",
                      marginLeft: "3px",
                    }}>
                    {Object.keys(props.facebook_conversion_objectives).map((objectiveName) => {
                      const objectiveInt = props.facebook_conversion_objectives[objectiveName];
                      return (
                        <option key={objectiveInt} value={objectiveName}>
                          {capitalize(objectiveName.split("_").join(" "))}
                        </option>
                      );
                    })}
                  </Form.Control>
                  {conversionObjective == "custom_conversions" && (
                    <CustomConversions customConversions={customConversions} setCustomConversions={setCustomConversions} />
                  )}
                </div>
                <div>
                  <p className="d-inline-block visby-bold primary f16 mb-3">Tiktok Objective </p>
                  <CustomTooltip
                    faClass="far fa-question-circle pl-2"
                    message="Choose which objective the Tiktok campaigns are targeting, typically 'Complete payment' for e-commerce and 'Complete registration' for Lead generation."
                    inline={true}
                  />
                  <Form.Control
                    className="primary mb-2"
                    size="md"
                    as="select"
                    value={tiktokConversionObjective}
                    onChange={(e) => setTiktokConversionObjective(e.target.value)}
                    style={{ width: "256px", paddingLeft: "20px", marginLeft: "3px" }}>
                    {Object.keys(props.tiktok_conversion_objectives).map((objectiveName) => {
                      const objectiveInt = props.tiktok_conversion_objectives[objectiveName];
                      return (
                        <option key={objectiveInt} value={objectiveName}>
                          {capitalize(objectiveName.split("_").join(" "))}
                        </option>
                      );
                    })}
                  </Form.Control>
                </div>
              </Col>
            ) : (
              <Col className="" style={{ gap: "20px" }}>
                <div className="mb-3">
                  <span className="visby-bold primary f16">Custom Conversions</span>
                  <span>
                  <CustomTooltip
                    faClass="far fa-question-circle pl-2"
                    message={
                      <div style={{ textAlign: "center" }}>
                        <p>To get a Conversion Action ID, go to Google Ads and open the Tools & Settings menu from the top right of the navbar. In the Measurement column, select Conversions. Next, select the conversion action from the list that appears. Once you have selected a conversion action, check the final URL of the page and look for the 'ctId' parameter. This will be equal to the Conversion Action's ID.</p>
                        <img src="https://digital-position.monday.com/protected_static/2205640/resources/991799417/large-conversion-action-ctid.jpg" alt="Conversion Aciton ID" style={{ maxWidth: "450px", display: "block", margin: "0 auto", marginTop: "10px" }}/>
                      </div>
                    }
                    inline={true}
                  />
                  </span>
                </div>
                <ConversionActionIds
                  cg={true}
                  conversionActionsEnabled={conversionActionsEnabled}
                  onChange={() => {
                    setConversionActionsEnabled(!conversionActionsEnabled);
                  }}
                  option="custom conversions"
                  conversionActions={conversionActions}
                  setConversionActions={setConversionActions}
                />
              </Col>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row className="mt-4">
            <Col md={7}>
              <Button
                style={{
                  paddingLeft: "35px",
                  paddingRight: "35px",
                  paddingTop: "8px",
                  paddingBottom: "8px",
                }}
                variant="danger"
                className="mt-0 mb-0 mt-sm-3 mb-sm-3"
                onClick={() => props.handleDeleteBox(props.draggableId)}>
                Delete campaign group
              </Button>
            </Col>
            <Col>
              <Button
                style={{
                  paddingLeft: "35px",
                  paddingRight: "35px",
                  paddingTop: "8px",
                  paddingBottom: "8 px",
                }}
                className="mt-3 mb-0 mb-sm-3 mr-0 mr-md-3 cancel-button"
                onClick={() => setShowBox(false)}>
                Cancel
              </Button>

              <Button
                style={{
                  paddingLeft: "25px",
                  paddingRight: "25px",
                  paddingTop: "8px",
                  paddingBottom: "8px",
                }}
                variant="success"
                className="mt-3 mb-0 mb-sm-3"
                onClick={handleSubmit}>
                Save campaign group
              </Button>
            </Col>
          </Row>
          {errorText.length > 0 && (
            <Row>
              <Col xs={12}>
                <Alert variant="danger">
                  {errorText.map((error, index) => {
                    return <p key={index}>{error}</p>;
                  }
                  )}
                </Alert>
              </Col>
            </Row>
          )}
        </Modal.Footer>
      </Modal>
    </div >
  );
}
